<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-tags" titulo="CADASTRO DE GRUPO DE PRODUTO">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{formulario.CODIGO || 'Novo'}}</strong>
            </span>
            <span v-if="formulario.DESCRICAO" class="mx-2">•</span>
            <span v-if="formulario.DESCRICAO" class="mr-2">
              {{formulario.DESCRICAO.substring(0,50)}}
            </span>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="salvar()" :disabled="!formularioValido || salvando">
            <i class="fa fa-save mr-1"></i> {{ salvando ? 'SALVANDO...' : 'GRAVAR' }}
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()" :disabled="salvando">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <!-- Dados Principais -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-info-circle"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Informações Principais</h6>
                  <small class="text-muted">Dados do grupo de produto</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="12" md="8">
                <label class="modal-label-premium">Descrição *</label>
                <b-form-input 
                  type="text" 
                  v-model="formulario.DESCRICAO" 
                  maxlength="50" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !formulario.DESCRICAO}"
                  placeholder="Informe a descrição do grupo"
                  ref="edDescricao">
                </b-form-input>
              </b-col>
              
              <b-col sm="12" md="4">
                <label class="modal-label-premium">Comissão</label>
                <vue-autonumeric 
                  v-model="formulario.COMISSAO" 
                  :options="formatoPercentual"
                  class="form-control rounded-pill shadow-xs text-right">
                </vue-autonumeric>
              </b-col>
            </b-row>
          </b-card>

          <!-- Observações -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-comment"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Observações</h6>
                  <small class="text-muted">Informações adicionais</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col sm="12" class="mb-3">
                <label class="modal-label-premium">Observação</label>
                <b-form-textarea 
                  v-model="formulario.OBS" 
                  rows="4"
                  maxlength="100"
                  class="rounded shadow-xs"
                  placeholder="Informe observações adicionais (opcional)">
                </b-form-textarea>
              </b-col>
            </b-row>
          </b-card>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import VueAutonumeric from 'vue-autonumeric'

export default {
  name: 'GrupoProdutoCadastro',
  components: {
    HeaderPadrao,
    VueAutonumeric
  },
  data () {
    return {
      formulario: {
        CODIGO: null,
        DESCRICAO: '',
        OBS: '',
        COMISSAO: null
      },
      formatoPercentual: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '2',
        roundingMethod: 'U',
        minimumValue: 0,
        maximumValue: 100,
        suffixText: ' %',
        modifyValueOnWheel: false
      },
      salvando: false,
      modoEdicao: false
    }
  },
  computed: {
    isDark() {
      return this.$store.getters['tema/IS_DARK']
    },
    formularioValido () {
      return this.formulario.DESCRICAO && this.formulario.DESCRICAO.trim().length > 0
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.modoEdicao = true
      this.carregarDados()
    }
  },
  methods: {
    carregarDados () {
      this.$http.get(`/api/protected/grupo/produto/getById/${this.$route.params.id}`)
        .then(response => {
          if (response.data && response.data.length > 0) {
            this.formulario = response.data[0]
          } else {
            this.$bvToast.toast('Grupo de produto não encontrado', { title: 'Erro', variant: 'danger' })
            this.voltar()
          }
        })
        .catch(error => {
          console.error('Erro ao carregar grupo de produto:', error)
          this.$bvToast.toast('Erro ao carregar dados', { title: 'Erro', variant: 'danger' })
          this.voltar()
        })
    },
    salvar () {
      if (!this.formularioValido) {
        this.$bvToast.toast('Preencha todos os campos obrigatórios', { title: 'Atenção', variant: 'warning' })
        return
      }

      this.salvando = true
      this.$store.commit('controle/setAguardando', true)

      const rota = this.modoEdicao
        ? '/api/protected/grupo/produto/edit'
        : '/api/protected/grupo/produto/post'

      this.$http.post(rota, this.formulario)
        .then(response => {
          this.$bvToast.toast(
            this.modoEdicao
              ? 'Grupo de produto atualizado com sucesso!'
              : 'Grupo de produto cadastrado com sucesso!',
            { title: 'Sucesso', variant: 'success' }
          )
          this.$store.commit('grupoProduto/SET_RECARREGAR_LISTA', true)
          this.voltar()
        })
        .catch(error => {
          console.error('Erro ao salvar grupo de produto:', error)
          this.$bvToast.toast('Erro ao salvar registro', { title: 'Erro', variant: 'danger' })
        })
        .finally(() => {
          this.salvando = false
          this.$store.commit('controle/setAguardando', false)
        })
    },
    voltar () {
      this.$router.push({ name: 'GrupoProdutoListagem' })
    }
  }
}
</script>

<style lang="scss" scoped>
.campo-desabilitado {
  background-color: #e9ecef !important;
  opacity: 0.7;
}

.modal-label-premium {
  font-weight: 600;
  font-size: 0.9rem;
  color: #495057;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/grupo-produto/GrupoProdutoCadastro.vue